<template>
  <v-dialog v-model="mostrado" persistent scrollable max-width="100%">
    <v-card>
      <v-card-title class="pt-2 pb-0">PAGOS</v-card-title>

      <v-divider class="my-2"></v-divider>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="3">
            <span class="h5 d-block"> <strong>Sede origen: </strong>{{ form.detalle_solicitud?.sede_origen }} </span>
            <span class="h5 d-block"> <strong>Banco origen: </strong>{{ form.detalle_solicitud?.banco_origen }} </span>
            <span class="h5 d-block">
              <strong>Cuenta origen: </strong>{{ form.detalle_solicitud?.cuenta_origen }}
            </span>
          </v-col>

          <v-col cols="12" md="3">
            <span class="h5 d-block"> <strong>Sede destino: </strong>{{ form.detalle_solicitud?.sede_destino }} </span>
            <span class="h5 d-block">
              <strong>Banco destino: </strong>{{ form.detalle_solicitud?.banco_destino }}
            </span>
            <span class="h5 d-block">
              <strong>Cuenta destino: </strong>{{ form.detalle_solicitud?.cuenta_destino }}
            </span>
          </v-col>

          <v-col cols="12" md="6">
            <span class="h5 d-block"> <strong>Detalle: </strong>{{ form.detalle_solicitud?.detalle }} </span>
            <span class="h5 d-block"> <strong>Clasificador: </strong>{{ form.detalle_solicitud?.clasificador }} </span>
            <span class="h5 d-block"> <strong>Importe: </strong>{{ form.detalle_solicitud?.importe }} </span>
          </v-col>

          <v-col cols="12">
            <v-btn
              v-if="accion === accionRegistrarPago"
              small
              color="primary"
              class="mr-2"
              @click="
                $refs.ModalFormRegistrarPagoDetalleSolicitudRef.abrir(
                  form.detalle_solicitud?.id,
                  form.detalle_solicitud,
                  pagosDetallesSolicitudes,
                )
              "
              title="Registrar">
              <v-icon>mdi-plus</v-icon>

              Registrar Pago
            </v-btn>

            <v-btn small class="mx-1" @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12">
            <v-progress-linear v-if="cargando" indeterminate color="primary"></v-progress-linear>

            <ListadoPagoDetalleSolicitud :rowData="pagosDetallesSolicitudes" />
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-2"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>

    <ModalFormRegistrarPagoDetalleSolicitud ref="ModalFormRegistrarPagoDetalleSolicitudRef" @actualizar="actualizar" />
  </v-dialog>
</template>

<script>
import ListadoPagoDetalleSolicitud from '../views/ListadoPagoDetalleSolicitud.vue';
import ModalFormRegistrarPagoDetalleSolicitud from './ModalFormRegistrarPagoDetalleSolicitud.vue';
import pagosDetallesSolicitudesService from '../services/pago-detalle-solicitud';
import { OPERACIONES_DETALLE_SOLICITUD } from '../utils';

export default {
  name: 'ModalRegistrarPagoDetalleSolicitud',
  components: {
    ListadoPagoDetalleSolicitud,
    ModalFormRegistrarPagoDetalleSolicitud,
  },
  data() {
    return {
      mostrado: false,
      accion: OPERACIONES_DETALLE_SOLICITUD.REGISTRAR_PAGO,
      accionRegistrarPago: OPERACIONES_DETALLE_SOLICITUD.REGISTRAR_PAGO,
      accionVerPago: OPERACIONES_DETALLE_SOLICITUD.VER_PAGO,
      form: {
        id: null,
        detalle_solicitud: null,
      },
      cargando: false,
      pagosDetallesSolicitudes: [],
      datosAuxiliares: null,
    };
  },
  methods: {
    abrir(accion, data, indice) {
      this.accion = accion;
      this.form.id = data.id;
      this.form.detalle_solicitud = data.detalle_solicitud[indice];

      this.datosAuxiliares = null;

      this.mostrado = true;
      this.listar();
    },
    cerrar() {
      this.mostrado = false;
      const estado = this.datosAuxiliares?.estado;
      if (estado) {
        this.$emit('establecerEstado', { id: this.form.detalle_solicitud.id, estado: estado });
      }
    },
    async listar() {
      this.pagosDetallesSolicitudes = [];
      this.cargando = true;

      try {
        const { data } = await pagosDetallesSolicitudesService.findAll({
          params: {
            detalle_solicitud_id: this.form.detalle_solicitud.id,
          },
        });

        this.pagosDetallesSolicitudes = data.datos;
      } catch (error) {
        window.console.error(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Ocurrió un error al obtener los pagos de los detalles de las solicitudes',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }
    },
    actualizar(data) {
      this.datosAuxiliares = data;
      this.listar();
    },
  },
};
</script>